<template>
  <div class="register-view">
    <site-menu theme="dark" class="menu"/>
    <div class="inner content">
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" ref="form">
        <input type="hidden" name="cmd" value="_s-xclick">
        <input type="hidden" name="hosted_button_id" value="AZU5WN3PU8CLW">
      </form>
      <form @submit.stop.prevent="submit">
        <div class="field-group">
          <div class="col-2">
            <div class="field">
              <transition name="fade">
                <label v-if="email">Email</label>
              </transition>
              <input name="email" v-validate="'email'" v-model="email" placeholder="Email *" />
              <span class="error">{{ errors.first('email') }}</span>
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="phone">Phone</label>
              </transition>
              <input name="phone" v-validate="'required'" v-model="phone" placeholder="Phone *" />
              <span class="error">{{ errors.first('phone') }}</span>
            </div>
          </div>
          <div class="col-2">
            <div class="field">
              <transition name="fade">
                <label v-if="firstName">First Name</label>
              </transition>
              <input name="firstName" v-validate="'required'" data-vv-as="first name" v-model="firstName" placeholder="First Name *" />
              <span class="error">{{ errors.first('firstName') }}</span>
            </div>
            <div class="field">
              <transition name="fade">
                <label v-if="lastName">Last Name</label>
              </transition>
              <input name="lastName" v-validate="'required'" data-vv-as="first name" v-model="lastName" placeholder="Last Name *" />
              <span class="error">{{ errors.first('lastName') }}</span>
            </div>
          </div>
          <div class="next" @click="submit">RSVP</div>
        </div>
      </form>
    </div>
    <divider />
    <illustration />
  </div>
</template>

<script>
  import { constants, formFactor } from '@/lib/utils'
  import BigButton from '@/components/BigButton.vue'
  import Illustration from '@/components/Illustration.vue'
  import Slideshow from '@/components/Slideshow.vue'
  import SiteMenu from '@/components/SiteMenu.vue'
  import Divider from '@/components/Divider.vue'
  import packages from '@/lib/packages'

  export default {
    name: 'register-view',
    components: { BigButton, Illustration, Slideshow, SiteMenu, Divider },
    data() {
      return {
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((result) => {
          const attendee = {
            email: this.email,
            phone: this.phone,
            firstName: this.firstName,
            lastName: this.lastName,
          }
          if (result) {
            this.$http.post('attendee', attendee)
            .then((response) => {
              this.$toasted.success('Thank you for registering. We\'re waiting for you at the US Capitol Visitor Center')
            })
            .catch(res => {
              const error = res.body ? res.body.error ? res.body.error : res.body : res
              this.$toasted.error(error)
            })
          }
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  .register-view {
    position: relative;
    .content {
      margin: 60px auto;
    }
  }
  .banner {
    color: #fff;
    position: absolute;
    top: 240px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    padding: 30px 0;
    text-align: center;
    font-size: 22px;
  }
  input, select {
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }
  form.step-1 {
    margin: 0 40px 40px 40px;
  }
  form.step-2 {
    margin: 40px 20px;
  }
  .required-notice {
    margin-top: 5px;
    opacity: 0.5;
  }
  .field-group {
    background: $color-8;
    padding: 40px;
    .field input, .field select {
      background: $color-8;
      color: #fff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.7);
      padding: 15px 0;
    }
    .field label {
      color: #fff;
      opacity: 0.5;
      top: 2px;
      left: 0;
    }
    ::placeholder {
      color: $color-9;
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: $color-9;
    }
    ::-ms-input-placeholder {
      color: $color-9;
    }
  }
  .instructions {
    color: $color-8;
    text-align: justify;
    opacity: 0.5;
  }
  .next {
    color: #fff;
    text-align: center;
    padding-top: 20px;
    font-size: 30px;
    opacity: 0.8;
    text-transform: uppercase;
    font-weight: 100;
    cursor: pointer;
    width: 200px;
    margin: 0 auto;
    &:hover {
      opacity: 1;
      font-weight: normal;
    }
  }
  .error {
    position: absolute;
    left: 0;
    bottom: -13px;
    width: 400px;
    color: lighten($red, 30%);
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 1px;
  }
  .actions {
    overflow: hidden;
    margin-bottom: 20px;
  }
  @media (max-width: 500px) {
    .register-view {
      padding-top: 0;
    }
    button.main {
      margin: 0 15px;
    }
    .register-view.inner .field {
      & {
        width: calc(100% - 30px);
      }
    }
    .q-wrapper {
      margin: 0 15px 20px 15px;
    }
    .mandatory-notice {
      margin-left: 15px;
    }
    form.step-1 {
      margin: 0 10px 40px 10px;
      .field {
        margin-top: 20px;
      }
    }
    form.step-2 {
      margin: 40px 10px;
    }
    .field-group {
      padding: 15px;
    }
    .instructions {
      font-size: 18px;
      margin: 60px auto 20px;
    }
    form.step-2 {
      margin: 60px 10px 40px;
    }
  }
  @media (min-width: 501px) {
    .register-view.inner .field {
      &:first-child {
        margin-left: 0;
      }
    }
    .q-wrapper {
      margin-bottom: 20px;
    }
    .col-2 .field {
      width: calc(50% - 24px);
    }
    .col-3 .field {
      width: calc(33.3333% - 24px);
      &.span-2 {
        width: calc(66.6666% - 24px);
      }
    }
    .col-4 .field {
      width: calc(25% - 24px);
    }
    .col-1 .field {
      width: 100%;
    }
    .col-2, .col-3, .col-4, .col-1 {
      width: 100%;
      overflow: hidden;
      .field {
        margin: 0 0 12px 24px;
        float: left;
      }
    }
    .instructions {
      font-size: 22px;
      width: 990px;
      margin: 40px auto 0;
    }
  }
</style>